import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {RootState} from "../../../../reducers";
import {OrderItemApi} from "../../../services/Api/types";
import AppConfig from "../../../services/AppConfig";
import {ReactComponent as MenuItemDarkIco} from "../../../../images/icons/menus/menu-item-dark.svg";
import {ReactComponent as MenuItemIco} from "../../../../images/icons/menus/menu-item.svg";
import SummaryItemItems from "./SummaryItemItems";
import Money from "../../../components/Common/Money";
import React from "react";

interface OwnProps {
    orderItem: OrderItemApi;
    items: Record<string, any>[];
    modifierGroups: Record<string, any>[];
    promotion: Record<string, any> | undefined;
    item: Record<string, any>;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

const SummaryItem = ({items, orderItem, item, promotion, modifierGroups}: Props) => {
    const {t} = useTranslation();

    const renderPrice = () => {
        if (orderItem.discount_money !== undefined && orderItem.discount_money.amount !== 0) {
            const subTotalPrice = orderItem.total_money.amount + orderItem.discount_money.amount;

            return (
                <>
                    <span className="text-muted me-2">
                        <del>
                        <Money
                            value={subTotalPrice}
                            currency='PLN'/>
                        </del>
                    </span>
                    <span className="text-danger">
                    <Money
                        value={orderItem.total_money.amount}
                        currency='PLN'/>
                    </span>
                </>
            )
        }

        return (
            <Money
                value={orderItem.total_money.amount}
                currency='PLN'/>
        )
    }

    return (
        <div className="cart-item">
            <div className="cart-item-img">
                {
                    item && item.image_small ? (
                        <img src={item.image_small} alt={t("common.word.product_image")}/>
                    ) : (
                        AppConfig.isDarkMode() ?
                            <MenuItemDarkIco className="img"/> : <MenuItemIco className="img"/>
                    )
                }
            </div>
            <div className="cart-item-body">
                <h3>
                    {item && item.translation?.name ? item.translation.name : orderItem.name}
                    {orderItem.quantity && orderItem.quantity > 1 && (
                        <span className="ms-1 text-muted fw-normal">
                                {`(x${orderItem.quantity})`}
                            </span>
                    )}
                </h3>
                <div className="cart-item-items">
                    <SummaryItemItems items={items} modifierGroups={modifierGroups} orderItem={orderItem}/>
                </div>
                {promotion && (
                    <div className="cart-item-promotion text-success">
                        {promotion.name}
                    </div>
                )}
                <div className="cart-item-prices">
                    {renderPrice()}
                </div>
                {item.comment && (
                    <div className="order-comment mt-2 rounded-2">
                        <p className="mb-0">{item.comment}</p>
                    </div>
                )}
            </div>
        </div>
    )

}

const mapStateToProps = (state: RootState) => ({})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(SummaryItem));